/** Clarity Group client-facing contact channels for Clarity One assistance cards. */
export const CLARITY_ONE_ASSISTANCE = {
  whatsAppUrl: "https://wa.me/6568885833",
  whatsAppLabel: "WhatsApp Clarity",
  phoneHref: "tel:+6568885833",
  phoneLabel: "+65 6888 5833",
  phoneDisplay: "Call Clarity",
  emailHref: "mailto:info@claritygroup.com.sg",
  emailLabel: "Email Clarity",
} as const;
